import { Navigate, Outlet, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  allowedRoles: string[];
  user?: { id: number; name: string; role: string } | null;
}

const ProtectedRoute = ({ allowedRoles, user }: ProtectedRouteProps) => {
  const location = useLocation();
  //console.log("ProtectedRoute user:", user);

  // If user is not authenticated
  if (!user) {
    //console.log(user);
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If user does not have required role
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
